import React from 'react';
import styled from '@emotion/styled';

import Icon from 'app/components/commons/Icon';

const StyledIcon = styled(Icon)({
  verticalAlign: 'text-top'
});

const RestrictedContestIcon = ({ size }) => (
  <StyledIcon type="icon-pyramid-chart" size={size} color="#800080" />
);

export default RestrictedContestIcon;
